import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ResponseModel, { PaginationRes } from "../../../models/response.model";
import { getProductionUnitsApi } from "../../../api/Factory/factory.api";
import { IProductionUnit } from "../../../models/factory/productionUnit.model";

interface CopyBomState {
  productionUnits: IProductionUnit[];
  pagination: {
    getProductionUnits?: PaginationRes;
  };
  loading: {
    getProductionUnits: boolean;
  };
}

const initialState: CopyBomState = {
  productionUnits: [],
  pagination: {},
  loading: {
    getProductionUnits: false,
  },
};

export const getProductionUnits = createAsyncThunk<
  ResponseModel,
  {
    params: {
      page: number;
      limit: number;
      search?: string;
      productId?: string;
      createdBy?: string;
      dispatchedStartDate?: string;
      dispatchedEndDate?: string;
      createdStartDate?: string;
      createdEndDate?: string;
      sortOrder?: "asc" | "desc";
    };
  },
  { rejectValue: string }
>("factory/getProductionUnits", async ({ params }, { rejectWithValue }) => {
  try {
    return await getProductionUnitsApi(params);
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || "Failed to fetch report",
    );
  }
});

const factorySlice = createSlice({
  name: "factory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductionUnits.pending, (state) => {
        state.loading.getProductionUnits = true;
      })
      .addCase(getProductionUnits.fulfilled, (state, action) => {
        state.loading.getProductionUnits = false;
        state.productionUnits = action.payload.data;
        state.pagination!.getProductionUnits = action.payload.pagination;
      })
      .addCase(getProductionUnits.rejected, (state, action) => {
        state.loading.getProductionUnits = false;
      });
  },
});

export default factorySlice.reducer;
